import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    rtl: true,
    theme: {
        themes: {
          light: {
            primary: '#3949AB',
            secondary: '#FB8C00',
            lighten: '#E8EAF6',
            accent: '#8c9eff',
            error: '#b71c1c',
          },
          dark:{
            // secondary:'#EDE7F6',
          }
        },
      },
});
